import Splide from '@splidejs/splide';
import { Translations } from '../utils';
import './immobili-slider.scss';

export class ImmobiliSlider {
  constructor() {
    this.el = document.querySelector('.js-immobili-slider');
    if (!this.el) return;

    this.init();
  }

  init() {
    const mq = window.matchMedia('(max-width: 767px)');
    const list = this.el.querySelector('.splide__list');
    const desktopOnlySlide = list.querySelector('.js-immobili-slider__desktop-only');

    if (mq.matches && desktopOnlySlide) {
      list.removeChild(desktopOnlySlide);
    }

    const splide = new Splide(this.el, {
      type: 'slide',
      arrows: true,
      pagination: false,
      gap: '1.5rem',
      // Variante pagina singolo immobile: 4 slide invece di 3.5
      perPage: this.el.classList.contains('js-immobili-slider--immobile') ? 4 : 3.5,
      focus: 0,
      trimSpace: true,
      snap: true,
      breakpoints: {
        992: {
          perPage: 2.5,
          pagination: true,
        },
        767: {
          perPage: 1,
          pagination: true,
        },
      },
      i18n: Translations.getSplideI18n(),
    });

    splide.mount();

    mq.addEventListener('change', () => {
      if (mq.matches) {
        if (desktopOnlySlide && list.contains(desktopOnlySlide)) {
          splide.remove(0);
        }
      } else if (desktopOnlySlide && !list.contains(desktopOnlySlide)) {
        splide.add(desktopOnlySlide, 0);
      }
    });

    const next = this.el.querySelector('.splide__arrow--next');
    const updateArrows = () => {
      if (!window.matchMedia('(min-width: 992px)').matches) return;
      const { index } = splide;
      const last = splide.length - splide.options.perPage;

      if (index >= last) {
        next.classList.add('is-disabled');
      } else {
        next.classList.remove('is-disabled');
      }
    };

    updateArrows();

    splide.on('mounted move', updateArrows);
  }
}
